




















import Vue from 'vue';

export default Vue.component('ConfirmDialog', {
    props: {
        show: Boolean,
        title: String,
        message: String,
        positiveButtonText: String,
        negativeButtonText: String,
        loading: Boolean,
        maxWidth: Number
    },
    data: function() {
        return {
            maxWidthInstance: (this.maxWidth) ? this.maxWidth : 290
        }
    }})
